import { atom, RecoilState } from "recoil";
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const AdvisoryReportAtom: RecoilState<{ id: number }> = atom<{ id: number }>({
    key: 'AdvisoryReportAtom',
    default: {
        id: -1
    } as { id: number },
    effects_UNSTABLE: [persistAtom]
});

